/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var MoyaOverlayClass = MoyaContainer.get('core.overlay').OverlayClass;
    var fetch = MoyaContainer.get('core.fetch');
    var toggle = MoyaContainer.get('core.toggle');
    var util = MoyaContainer.get('core.util');
    var OverlayStyle;
    (function (OverlayStyle) {
        OverlayStyle["LIGHT"] = "light";
    })(OverlayStyle || (OverlayStyle = {}));
    MoyaComponents.register('conference.search-form', function (el) {
        var item = new SearchForm(el);
        item.run();
    });
    var SearchForm = /** @class */ (function () {
        function SearchForm(el) {
            this.form = el;
        }
        SearchForm.prototype.run = function () {
            var _this = this;
            this.bindToggle();
            this.bindParticipantCount();
            this.form.addEventListener('change', (function (e) {
                e.preventDefault();
                var url = _this.buildUrlFromForm(_this.form);
                var config = {
                    url: url,
                    srcDestPairs: [
                        { srcSelector: '#conference .results' },
                    ],
                    shouldReplaceState: true,
                };
                _this.fetchFindReplace(config).then(function () {
                    conference.front.carousel();
                });
            }));
        };
        SearchForm.prototype.fetchFindReplace = function (config) {
            if (config.shouldReplaceState === true) {
                history.replaceState({}, null, config.url);
            }
            var opts = {
                url: config.url,
                method: config.method ? config.method : "GET",
                data: config.data,
            };
            var overlays = [];
            config.srcDestPairs.forEach(function (srcDest) {
                var sourceElem = document.querySelector(srcDest.srcSelector);
                if (!sourceElem) {
                    return;
                }
                if (!srcDest.destSelector) {
                    srcDest.destSelector = srcDest.srcSelector;
                }
                var overlay = new MoyaOverlayClass(sourceElem, { style: OverlayStyle.LIGHT });
                if (config.shouldShowOverlay !== false) {
                    overlay.show("spinner" /* SPINNER */);
                }
                var fetchFindReplaceData = {
                    source: sourceElem,
                    destination: srcDest.destSelector,
                    overlay: overlay,
                };
                overlays.push(fetchFindReplaceData);
            });
            return new Promise(function (resolve) {
                fetch.fetchHtml(opts)
                    .then(function (res) {
                    overlays.forEach(function (fetchFindReplaceData) {
                        var destElem = res.querySelector(fetchFindReplaceData.destination);
                        if (destElem) {
                            fetchFindReplaceData.source.innerHTML = destElem.innerHTML;
                            MoyaComponents.run(fetchFindReplaceData.source);
                        }
                        if (config.shouldShowOverlay !== false) {
                            fetchFindReplaceData.overlay.hide();
                        }
                        resolve(fetchFindReplaceData);
                    });
                });
            });
        };
        SearchForm.prototype.buildUrlFromForm = function (form) {
            var queryParams = [];
            var formData = new FormData(form);
            formData.forEach(function (value, key) {
                if (!value) {
                    return;
                }
                queryParams.push([key, value.toString()]);
            });
            var searchParams = new URLSearchParams(queryParams);
            var action = form.action;
            return action + '?' + searchParams.toString();
        };
        SearchForm.prototype.bindToggle = function () {
            var toggleElem = document.querySelector('#venuesLocation');
            var openElem = document.querySelector('#fieldset-dropdown');
            toggle.create(toggleElem, openElem, 'conference-search', {});
        };
        SearchForm.prototype.bindParticipantCount = function () {
            var _this = this;
            util.delegate(this.form, 'keyup', '#participantsCount', function () {
                clearTimeout(_this.timeout);
                _this.timeout = setTimeout(function () {
                    _this.form.dispatchEvent(new Event('change', { bubbles: true }));
                }, 400);
            });
        };
        return SearchForm;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
